import { render, staticRenderFns } from "./r-list-item.vue?vue&type=template&id=fbf155d0"
import script from "./r-list-item.vue?vue&type=script&lang=js"
export * from "./r-list-item.vue?vue&type=script&lang=js"
import style0 from "./r-list-item.vue?vue&type=style&index=0&id=fbf155d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports